import React, { useState } from 'react';
import { View, Pressable } from 'react-native';
import { useQuery, useMutation } from '@apollo/client';
import DataTable from '@preflighttech/preflight-tables';

import { Text, Title } from 'app/src/styles';
import { Actions, Action, ActionText } from 'app/src/styles/table';

import NewMailForward from './new';
import EditMailForward from './edit';
import { MAIL_FORWARDS, DESTROY_MAIL_FORWARD } from './queries';

const COLUMNS = [
  {
    key: 'id',
    label: 'ID',
  },
  {
    key: 'source',
    label: 'Source',
    sort: 'asc',
  },
  {
    key: 'destination',
    label: 'Destination',
  },
  {
    key: 'actions',
    label: 'Actions',
    sort: 'prevent',
    content: () => '',
  },
];

const MailForwards = () => {
  const [showNew, setShowNew] = useState();
  const [showEdit, setShowEdit] = useState();

  const { data, refetch } = useQuery(MAIL_FORWARDS);

  const [destroyMailForward] = useMutation(DESTROY_MAIL_FORWARD, {
    onCompleted: () => refetch()
  });

  const confirmDestroy = mailForward => {
    const confirmation = `Really destroy ${mailForward.source}?`;

    if (window.confirm(confirmation)) {
      destroyMailForward({ variables: { id: mailForward.id } });
    }
  };

  const columns = [...COLUMNS];

  columns[columns.length - 1].content = ({ entry }) => (
    <Actions style={{ flexWrap: 'no-wrap' }}>
      <Action first>
        <Pressable onPress={() => setShowEdit(entry)}>
          <ActionText>Edit</ActionText>
        </Pressable>
      </Action>

      <Action>
        <Pressable onPress={() => confirmDestroy(entry)}>
          <ActionText>Destroy</ActionText>
        </Pressable>
      </Action>
    </Actions>
  );

  return (
    <View>
      <Title>Email Forwards</Title>

      <Pressable onPress={() => setShowNew({})}>
        <Text>Add Forward</Text>
      </Pressable>

      {data && (
        <DataTable.Simple
          data={data.mailForwards}
          columns={columns}
          pageLength="All"
          htmlTable
        />
      )}

      {showNew && (
        <NewMailForward
          setShow={setShowNew}
          refetch={refetch}
          domains={data.domains}
        />
      )}

      {showEdit && (
        <EditMailForward
          mailForward={showEdit}
          setShow={setShowEdit}
          refetch={refetch}
          domains={data.domains}
        />
      )}
    </View>
  );
};

export default MailForwards;
